export default class Vector {
  x: number;

  y: number;

  z: number;

  constructor(
    x?: number,
    y?: number,
    z?: number,
  ) {
    this.x = x || 0;
    this.y = y || 0;
    this.z = z || 0;
  }

  length3dTo(n: Vector): number {
    return Math.sqrt((this.x - n.x) ** 2 + (this.y - n.y) ** 2 + (this.z - n.z) ** 2);
  }
}
